// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which of the two LN1 translation maps a key participates in.
 *
 * `Ln1.Mapping` carries two independent maps: `offset_to_msg` (a byte read
 * FROM the device becomes an LN2 message) and `msg_to_offset` (an LN2
 * message becomes bytes written TO the device). Historically one key fed
 * both, so a wire offset had exactly one LN2 identity in either direction.
 *
 * Some controllers reuse one address asymmetrically: on a Swift CEC, byte 8
 * written TO the controller energizes an up hall call, while byte 8 read
 * FROM it reports a down hall call. `TO_DEVICE`/`FROM_DEVICE` let one key
 * claim a single map, so a second key may claim the other with a different
 * LN2 message.
 *
 * BOTH IS 0 AND IS THE DECLARED DEFAULT, DELIBERATELY. `FlatBuffers` omits a
 * field equal to its declared default and substitutes that default for an
 * absent slot, so every key written before this field existed decodes as
 * BOTH — exactly the historical one-key-feeds-both-maps behaviour. A 0 that
 * meant `TO_DEVICE` would silently empty `offset_to_msg` for every adapter
 * already in the field. Never reorder these and never change the default:
 * `scripts/check_schema_compat.bash` enforces append-only ordering, but
 * nothing enforces the choice of default.
 *
 * Stored as `smallint` in `LiftCloud` (not a `PostgreSQL` enum type) — see
 * `RecurrenceMode`/`ModifierDirection` for the same treatment. `LiftCloud` has
 * no migration runner, so a column typed as a custom PG enum would fail
 * `AutoMigrate` on any database lacking the type.
 */
export enum KeyDirection {
  BOTH = 0,
  TO_DEVICE = 1,
  FROM_DEVICE = 2,
}
